import React, { useState, Component, useMemo, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import DataTable from "../_Components/DataTable";

import _ from "lodash";
import SwalMessage from "../_Components/SwalMessage";

import moment from "moment-jalaali";
import { green } from "@mui/material/colors";
import { ShowPromoCodeUsersModal } from "./ShowPromoCodeUsersModal";
import { func } from "prop-types";
import { Button } from "react-bootstrap";
// import ApiPublicPromoCodeService from "../../../core/api/api.publicPromoCode";
let showPrice = Intl.NumberFormat("en-US");

function DataGridAllPrivatePromoCode(props) {
  let location = useLocation();

  const [userListPromoCode, setuserListPromoCode] = useState([]);
  function clickCountUser(itemsClick) {
    setuserListPromoCode(itemsClick);
    //history.push("privatePromoCodeList/0")
  }
  function callBack() {
    setuserListPromoCode([]);
  }
  const columns = useMemo(() => [
    {
      accessor: "id",
      Header: "شماره",
      minWidth: 50,
    },
    {
      accessor: "agentName",
      Header: "نماینده فروش",
      minWidth: 100,
      Cell: ({ row }) => (
        <div className="ltr">{row.original?.agent != null ? row.original?.agent?.companyName : "-"}</div>
      ),
    },
    {
      accessor: "code",
      Header: "کد تخفیف",
      minWidth: 100,
    },

    {
      accessor: "promoCodeUser",
      Header: "نام و نام خانوادگی گردشگر",
      minWidth: "170px",
      Cell: ({ row }) => (
        <div className="ltr">
          {row.original?.promoCodeUser != null
            ? row.original?.promoCodeUser[0]?.userFirstname + " " + row.original?.promoCodeUser[0]?.userLastName
            : "-"}
        </div>
      ),
    },
    {
      accessor: "promoCodeUser[0].userPhoneNumber",
      Header: "شماره همراه گردشگر",
      minWidth: "130px",
    },
    {
      accessor: "userCheckInDate",
      Header: "تاریخ ورود",
      minWidth: "100px",
      Cell: ({ row }) => (
        <div className="ltr">
          {row.original?.promoCodeUser != null ? row.original?.promoCodeUser[0]?.userCheckInDate : "-"}
        </div>
      ),
    },
    {
      accessor: "expireDate",
      Header: "تاریخ انقضا",
      minWidth: "100px",
      Cell: ({ row }) => <>{row.original?.expireDate}</>,
    },

    {
      accessor: "promoCategoryS",
      Header: "نام گروه تخفیف",
      minWidth: "100px",
    },

    {
      accessor: "createdPersianTime",
      Header: "زمان ایجاد",
      minWidth: "150px",
      Cell: ({ row }) => (
        <div className="ltr">
          {row.original?.createdPersianTime != null ? row.original?.createdPersianTime : "-"}
        </div>
      ),
    },
    {
      Header: "وضعیت کد تخفیف",
      minWidth: "130px",
      align: "center",
      Cell: ({ row }) => (
        <div
          className={`text-center rounded-pill d-inline-block px-4 py-1  ${row.original.isDeleted ? " text-danger bg-light-danger" : " text-success bg-light-success"}`}
        >
          {row.original.isDeleted ? "غیر فعال " : "فعال"}
        </div>
      ),
    },
    {
      Header: "عملیات",
      accessor: "",
      minWidth: 100,
      align: "center",
      Cell: ({ row }) => (
        <div className="text-center">
          {/* ویرایش */}
          <Button
            className="btn btn-light-primary btn-sm mr-2 btn-icon"
            title="ویرایش"
            onClick={() => {
              props.setSelectedPromoCode(row.original)
            }}
          >
            <i className="far fa-edit text-small"></i>
          </Button>
        </div>
      ),
    },
  ]);

  const config = {
    page_size: 10,
    length_menu: [10, 20, 50, 100],
    show_filter: true,
    show_pagination: true,
    pagination: "advance",
    button: {
      excel: false,
      print: false,
    },
    language: {
      length_menu: " _MENU_  رکورد در هر صفحه",
      filter: "جستجو ...",
      info: " _START_ - _END_ از _TOTAL_ رکورد",
      pagination: {
        first: "First",
        previous: <i className="fa fa-chevron-right"></i>,
        next: <i className="fa fa-chevron-left"></i>,
        last: "Last",
      },
    },
  };
  return (
    <div>
      {!_.isEmpty(userListPromoCode) ? (
        <ShowPromoCodeUsersModal userList={userListPromoCode} callBack={callBack} />
      ) : (
        <></>
      )}
      <DataTable config={config} columns={columns} data={props.data} />
    </div>
  );
}

export default DataGridAllPrivatePromoCode;
